<template>
	<div>
        <form action="#">
            <div class="form-group">
                <label for="emailaddress">Логин</label>
                <input class="form-control" type="text" required placeholder="Введите логин" v-model="form.login">
            </div>

            <div class="form-group">
                <label for="password">Пароль</label>
                <input class="form-control" type="password" required id="password" placeholder="Введите пароль" v-model="form.password">
            </div>

            <div class="form-group mb-0 text-center">
                <button v-if="!loading" class="btn btn-primary" type="submit" @click.prevent="submitForm()"> Войти </button>
                <button v-else class="btn btn-primary" type="button" disabled>
                    <span class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
                    Отправка данных...
                </button>
            </div>
        </form>
    </div>
</template>

<script>
import log from '@/plugins/log'
import { to } from '@/plugins/utils'


export default {
	name: 'Setup',
    data: () => {
        return {
            form: {
                login: '',
                password: ''
            },
            loading: false
        }
    },
    mounted() {
        log.debug('/views/empty/Login', 'mounted')
    },
    methods: {
        async submitForm() {
            if(this.loading) return $.NotificationApp.send("Ошибка", "Подождите", "top-right", "", "error")

            if(!this.form.login) return $.NotificationApp.send("Ошибка", "Введите логин", "top-right", "", "error")
            if(!this.form.password) return $.NotificationApp.send("Ошибка", "Введите пароль", "top-right", "", "error")

            this.loading = true

            var [err, response] = await to( this.$http.post('/auth/login', this.form) )
            if(err) {
                this.loading = false
                log.error('/views/empty/Login', 'methods.submitForm', '$http.request', err)
                return $.NotificationApp.send("Ошибка", err.message, "top-right", "", "error")
            }
            if(!response.data.success) {
                this.loading = false
                log.error('/views/empty/Login', 'methods.submitForm', '$http.response', response.data)
                return $.NotificationApp.send("Ошибка", response.data.error, "top-right", "", "error")
            }
            this.loading = false

            this.$store.commit('set_app_token', response.data.accessToken)
            this.$http.defaults.headers.common['Authorization'] = response.data.accessToken;

            this.$store.dispatch('get_status');
            this.$router.push('/');
        }
    }
};
</script>
